import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconEyeOpen: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M21.9923 11.7113C22 11.7331 22 11.7575 22 11.8V12V12.2C22 12.25 21.975 12.275 21.95 12.3C21.925 12.325 21.9 12.35 21.9 12.4V12.5C21.883 12.517 21.8441 12.5711 21.7833 12.6558C21.1307 13.5648 17.9461 18 12 18C6.05387 18 2.86931 13.5648 2.21666 12.6558C2.15587 12.5711 2.11704 12.517 2.1 12.5V12.4C2.0425 12.3425 2.01806 12.3181 2.00767 12.2887C2 12.2669 2 12.2425 2 12.2V12V11.8C2 11.75 2.025 11.725 2.05 11.7C2.075 11.675 2.1 11.65 2.1 11.6V11.5C2.12317 11.4768 2.17317 11.4054 2.25 11.2955C2.50483 10.9313 3.05483 10.1452 3.9 9.3L2.3 7.7C1.9 7.3 1.9 6.7 2.3 6.3C2.7 5.9 3.3 5.9 3.7 6.3L5.5 8.1L7 7.2L6.1 5.4C5.9 5 6.1 4.4 6.6 4.1C7 3.9 7.6 4.1 7.9 4.6L8.8 6.4C9.0196 6.36863 9.23919 6.32742 9.46188 6.28563C9.94903 6.1942 10.451 6.1 11 6.1V4C11 3.4 11.5 3 12.1 3C12.7 3 13.1 3.4 13.1 4V6.2C13.9 6.3 14.6 6.4 15.3 6.6L16.2 4.7C16.4 4.3 17 4.1 17.5 4.3C17.9 4.5 18.1 5.1 17.9 5.6L17 7.3C17.4 7.5 17.7111 7.7 18.0222 7.9C18.1778 8 18.3333 8.1 18.5 8.2L20.3 6.4C20.7 6 21.3 6 21.7 6.4C22.1 6.8 22.1 7.4 21.7 7.8L20.1 9.4C20.9641 10.1855 21.5196 10.9711 21.7667 11.3203C21.8341 11.4157 21.8786 11.4786 21.9 11.5V11.6C21.9575 11.6575 21.9819 11.6819 21.9923 11.7113ZM4.2 12C5.1 13.2 7.7 16 12 16C16.3 16 18.9 13.2 19.8 12C18.9 10.8 16.3 8 12 8C7.7 8 5.1 10.8 4.2 12ZM12 8C14.2 8 16 9.8 16 12C16 14.2 14.2 16 12 16C9.8 16 8 14.2 8 12C8 9.8 9.8 8 12 8ZM10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10C10.9 10 10 10.9 10 12Z',
    })
  )
}
